/** Use as the canonical value for Aave V2 positions and summaries. */
export const AAVE_V2_PROTOCOL_SLUG = 'aave-v2';
/** Use as the canonical value for Aave V3 positions and summaries. */
export const AAVE_V3_PROTOCOL_SLUG = 'aave-v3';
/** Use as the canonical value for Compound V2 positions and summaries. */
export const COMPOUND_V2_PROTOCOL_SLUG = 'compound-v2';
/** Use as the canonical value for Compound V3 positions and summaries. */
export const COMPOUND_V3_PROTOCOL_SLUG = 'compound-v3';
/** Use as the canonical value for Morpho positions and summaries. */
export const MORPHO_PROTOCOL_SLUG = 'morpho';
/** Accepted alias for Morpho — matches Morpho's current product naming ("Morpho Blue"). Routes to the same handler as `MORPHO_PROTOCOL_SLUG`. */
export const MORPHO_BLUE_PROTOCOL_SLUG = 'morpho-blue';
/** Use as the canonical value for Lido positions and summaries. */
export const LIDO_PROTOCOL_SLUG = 'lido';
/** Use as the canonical value for Curve pool and LP data. */
export const CURVE_PROTOCOL_SLUG = 'curve';
/** Use as the canonical value for Curve Llamalend markets. */
export const CURVE_LLAMALEND_PROTOCOL_SLUG = 'curve-llamalend';
/** Use as the canonical value for Pendle V2 positions and market data. */
export const PENDLE_V2_PROTOCOL_SLUG = 'pendle-v2';
/** Use when a field should only allow supported DeFi position protocols. */
export const DEFI_POSITION_PROTOCOL_SLUGS = [
    AAVE_V2_PROTOCOL_SLUG,
    AAVE_V3_PROTOCOL_SLUG,
    COMPOUND_V2_PROTOCOL_SLUG,
    COMPOUND_V3_PROTOCOL_SLUG,
    MORPHO_PROTOCOL_SLUG,
    MORPHO_BLUE_PROTOCOL_SLUG,
    LIDO_PROTOCOL_SLUG,
];
/**
 * Canonical mapping from a position-protocol slug to the JSON-RPC method
 * name the Spectrum API exposes for that protocol. Use this for any client
 * that wants to dispatch on `protocol` rather than calling each method
 * directly. The `satisfies` constraint guarantees every slug in
 * `DEFI_POSITION_PROTOCOL_SLUGS` has a corresponding method — adding a slug
 * without a method is a compile-time error. Multiple slugs may map to the
 * same method (e.g. `'morpho'` and `'morpho-blue'` both → `getMorphoUserPositions`).
 */
export const DEFI_POSITION_METHOD_BY_SLUG = {
    [AAVE_V2_PROTOCOL_SLUG]: 'getAaveV2UserPositions',
    [AAVE_V3_PROTOCOL_SLUG]: 'getAaveV3UserPositions',
    [COMPOUND_V2_PROTOCOL_SLUG]: 'getCompoundV2UserPositions',
    [COMPOUND_V3_PROTOCOL_SLUG]: 'getCompoundV3UserPositions',
    [MORPHO_PROTOCOL_SLUG]: 'getMorphoUserPositions',
    [MORPHO_BLUE_PROTOCOL_SLUG]: 'getMorphoUserPositions',
    [LIDO_PROTOCOL_SLUG]: 'getLidoUserPositions',
};
